import { createConsumer, type Consumer } from "@rails/actioncable"

declare global {
  interface Window {
    __appCableConsumer?: Consumer
  }
}

export const getAppCableConsumer = (): Consumer => {
  if (!window.__appCableConsumer) {
    window.__appCableConsumer = createConsumer()
  }

  return window.__appCableConsumer
}

export const disconnectAppCableConsumer = (): void => {
  window.__appCableConsumer?.disconnect()
  window.__appCableConsumer = undefined
}
